<div class="justify-content-center mb-4 pb-2 row">
  <div class="col-12">
    <mbs-stepper [steps]="parentSteps"
                 (stepChanged)="stepChangeHandler($event)"
                 size="lg"></mbs-stepper>
  </div>
</div>

<div class="mt-3">
  <mbs-alert *ngIf="errorMessage"
             [type]="mbsPopupType.danger"
             [closable]="true"
             [icon]="true"
             (close)="removeError()">{{ errorMessage }}</mbs-alert>
</div>

<ng-container *ngIf="stepsService.currentStep.getValue().id === stepId.AgentInstallation">
  <mbs-onboarding-installation-step [view]="installationView"
                                    [hold]="heedHoldInstallStep"
                                    [buildsSelectionConfig]="buildsSelectionConfig"
                                    (updateNextButton)="updateNextButton.emit($event)"
                                    (stable)="onboardingService.stable$.next($event)"
                                    (hasError)="onboardingService.hasError$.next($event)"
                                    (completed)="onDownloadBuildStepCompleted($event)"></mbs-onboarding-installation-step>
</ng-container>

<ng-container *ngIf="stepsService.currentStep.getValue().id === stepId.StorageAccount">
  <mbs-onboarding-storage-account-step [mode]="mode"
                                       [viewMode]="viewMode"
                                       [b2CredentialsForm]="b2CredentialsForm"></mbs-onboarding-storage-account-step>
</ng-container>

<ng-container *ngIf="stepsService.currentStep.getValue().id === stepId.BackupSource">
  <mbs-onboarding-source-step [plan]="plan"
                              [initialData]="backupData"
                              [settings]="{hid,isUnix, isNBF: !this.isUnix, backupVersionUpdated}"
                              (planTypeChanged)="onPlanTypeChanged($event)"
                              (selectedData)="onBackupDataChanged($event)"></mbs-onboarding-source-step>
</ng-container>

<ng-container *ngIf="stepsService.currentStep.getValue().id === stepId.Notifications">
  <mbs-onboarding-notifications-step [accountEmail]="provider.Email"
                                     [initialData]="notificationsData"
                                     (notificationsChanged)="onNotificationsDataChanged($event)"></mbs-onboarding-notifications-step>
</ng-container>

